import Seo from "@/components/Seo";
import React from "react";
import { Link } from "react-router-dom";
import PageMasthead from "@/components/PageMasthead";
import { Stagger, StaggerItem } from "@/components/motion";
import useApi from "@/hooks/useApi";

const News = () => {
  const { data } = useApi("/news");
  const list = data || [];

  const newsLd = list.length
    ? {
        "@context": "https://schema.org",
        "@type": "ItemList",
        itemListElement: list.map((n, i) => ({
          "@type": "ListItem",
          position: i + 1,
          url: n.slug ? `/news/${n.slug}` : undefined,
          item: {
            "@type": "NewsArticle",
            headline: n.title,
            datePublished: n.date,
            description: n.excerpt || undefined,
            image: n.image || undefined,
            publisher: { "@type": "Organization", name: "Which Media" },
          },
        })),
      }
    : undefined;

  return (
    <div data-testid="news-page">
      <Seo
        title="News & Press"
        path="/news"
        description="Announcements, press releases and research from across the Which Media group — WhichSchoolAdvisor.com, SchoolsCompared.com, Top Schools Awards, EdinformaPlus and the Education Intelligence Group."
        jsonLd={newsLd}
      />
      <PageMasthead
        kicker="News & Press"
        titleLines={[{ text: "From the" }, { text: "newsroom", accent: true }]}
        standfirst="Announcements, press and research from across the Which Media group."
      />

      <section className="mx-auto max-w-[1400px] px-5 md:px-8 py-14 md:py-20">
        <Stagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {list.map((n) => (
            <StaggerItem key={n.id}>
              <Link
                to={n.slug ? `/news/${n.slug}` : "/news"}
                data-testid={`news-card-${n.slug || n.id}`}
                className="group block text-left w-full"
              >
                <div className="ed-img aspect-[16/10] rounded-2xl mb-5">
                  <img src={n.image || undefined} alt={n.title} />
                </div>
                <div className="flex items-center gap-3 mb-2">
                  <span className="kicker">{n.category}</span>
                  <span className="text-xs font-bold text-foreground/40">{n.date}</span>
                </div>
                <h3 className="headline text-2xl text-ink group-hover:text-primary transition-colors leading-tight">
                  {n.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-foreground/70">{n.excerpt}</p>
              </Link>
            </StaggerItem>
          ))}
        </Stagger>
      </section>
    </div>
  );
};

export default News;
